import { ReactNode } from "react";

interface Props {
  truthy: boolean;
  children: ReactNode;
}

export const When = ({ truthy, children }: Props) =>
  truthy ? <>{children}</> : null;
